import { SortDir } from '__generated__';
import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import bind from 'memoize-bind';
import React, { PureComponent } from 'react';

import CaretDown from '@sbu/assets.svg/src/caret-down.svg';
import CaretUp from '@sbu/assets.svg/src/caret-up.svg';

import { SortContext } from './SortContext';
import css from './SortHeader.module.scss';

interface SortHeaderProps {
  prop: string;
  className?: any;
}

export class SortHeader extends PureComponent<
  React.PropsWithChildren<SortHeaderProps>
> {
  context: any;
  static contextType = SortContext;

  onSortClick() {
    this.context.onHeaderClick(this.props.prop);
  }

  onKeydown(event: React.KeyboardEvent<HTMLDivElement>) {
    if (event.key === 'Enter' || event.key === 'Space') {
      this.context.onHeaderClick(this.props.prop);
    }
  }

  renderSortIndicator() {
    const sort = this.context.sorts.find((s) => s.prop === this.props.prop);

    return (
      <AnimatePresence initial={false}>
        {sort && sort.direction === SortDir.Asc && (
          <motion.div
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 15, transition: { duration: 0.05 } }}
            initial={{ opacity: 0, y: -15 }}
            key={`${sort.prop}-asc`}
          >
            <CaretUp className={css.icon} />
          </motion.div>
        )}
        {sort && sort.direction === SortDir.Desc && (
          <motion.div
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 15, transition: { duration: 0.05 } }}
            initial={{ opacity: 0, y: -15 }}
            key={`${sort.prop}-desc`}
          >
            <CaretDown className={css.icon} />
          </motion.div>
        )}
      </AnimatePresence>
    );
  }

  render() {
    const { className } = this.props;

    return (
      <div
        className={classNames(css.button, className)}
        onClick={bind(this.onSortClick, this)}
        onKeyDown={bind(this.onKeydown, this)}
        role='button'
        tabIndex={-1}
      >
        {this.props.children}
        <div>{this.renderSortIndicator()}</div>
      </div>
    );
  }
}
